module.exports = __webpack_public_path__ + "img/japan-breast-cancer-female.23a351cb.png";